import { render, staticRenderFns } from "./TableAndMapaSolicitacoes.vue?vue&type=template&id=60d45f22&scoped=true&"
import script from "./TableAndMapaSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./TableAndMapaSolicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./TableAndMapaSolicitacoes.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TableAndMapaSolicitacoes.vue?vue&type=style&index=1&id=60d45f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d45f22",
  null
  
)

export default component.exports